import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'store';
import { useStorage64 } from 'hooks';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { AGENT_STAFF } from 'constants/storage64';
import GiftsHeader from '../GiftsHeader';

const GiftsLayout = ({ children }) => {
  const [storageAgentStaffId, setAgentStaffId] = useStorage64(AGENT_STAFF, '');
  const [agentStaffId] = useStore((state) => state.commons.agentStaffId);

  useEffect(() => {
    if (!storageAgentStaffId) {
      setAgentStaffId(null);
    }
  }, [storageAgentStaffId, agentStaffId]);

  return (
    <>
      {!agentStaffId && (
        <div>
          <Header type="complete" />
        </div>
      )}

      <main className="gifts-root">
        {!agentStaffId && (
          <div>
            <GiftsHeader />
          </div>
        )}

        {children}
      </main>

      {!agentStaffId && <Footer type="complete" />}
    </>
  );
};

GiftsLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default GiftsLayout;
